"use client";

import React, { useState, useEffect, useRef } from "react";
import Sketch from "react-p5";
import p5Types from "p5";
import { ArrowRight, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ConsulenzaItStrategica() {
  const [parentWidth, setParentWidth] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (containerRef.current) {
      setParentWidth(containerRef.current.offsetWidth);
    }
    const handleResize = () => {
      if (containerRef.current) {
        setParentWidth(containerRef.current.offsetWidth);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const setup = (p5: p5Types, canvasParentRef: Element) => {
    p5.createCanvas(parentWidth || 500, 500, p5.WEBGL).parent(canvasParentRef);
  };
  const draw = (p5: p5Types) => {
    p5.background(15, 23, 41);
    p5.ambientLight(60);
    p5.directionalLight(255, 255, 255, 0, 0, -1);
    p5.pointLight(6, 182, 212, 200, 200, 200);
    p5.rotateY(p5.frameCount * 0.005);
    p5.rotateX(p5.frameCount * 0.002);
    p5.noFill();
    p5.strokeWeight(1.5);
    const rackHeight = 240;
    const rackWidth = 140;
    const rackDepth = 140;
    const units = 6;
    const unitHeight = rackHeight / units;
    p5.translate(0, 0, 0);
    p5.stroke(100, 116, 139);
    p5.box(rackWidth + 20, rackHeight + 20, rackDepth + 20);
    for (let i = 0; i < units; i++) {
      p5.push();
      const yPos = -rackHeight / 2 + i * unitHeight + unitHeight / 2;
      p5.translate(0, yPos, 0);
      const alpha = 150 + 100 * Math.sin(p5.frameCount * 0.05 + i);
      p5.stroke(6, 182, 212, alpha);
      p5.box(rackWidth, unitHeight - 10, rackDepth);
      p5.strokeWeight(1);
      p5.stroke(6, 182, 212, 50);
      p5.line(-rackWidth / 2, 0, -rackDepth / 2, rackWidth / 2, 0, rackDepth / 2);
      p5.line(-rackWidth / 2, 0, rackDepth / 2, rackWidth / 2, 0, -rackDepth / 2);
      p5.pop();
    }
  };
  const windowResized = (p5: p5Types) => {
    if (containerRef.current) {
      p5.resizeCanvas(containerRef.current.offsetWidth, 500);
    }
  };
  return <section id="consulenza-it-strategica" className="dark bg-background text-foreground relative overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[400px] h-[400px] bg-blue-900/20 rounded-full blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          
          {}
          <div className="w-full lg:w-3/5 space-y-8 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary/50 border border-border/50 backdrop-blur-sm">
              <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
              <span className="text-xs font-mono text-muted-foreground uppercase tracking-wider">CONSULENZA IT </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.1]">
              <span className="bg-gradient-to-r from-white via-slate-200 to-slate-400 bg-clip-text text-transparent">
                Consulenza IT per infrastrutture e tecnologie aziendali
              </span>
            </h1>

            <p className="text-lg md:text-xl text-muted-foreground font-mono leading-relaxed max-w-2xl mx-auto lg:mx-0">B-Tech supporta le aziende nella progettazione, gestione e ottimizzazione<div>delle infrastrutture IT, dei dispositivi aziendali e delle tecnologie&nbsp;<span style={{
                color: 'rgb(148, 163, 184)',
                letterSpacing: '-0.32px'
              }}>utilizzate nelle attività operative.</span></div></p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 pt-4">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-[0_0_20px_-5px_var(--color-primary)] hover:shadow-[0_0_30px_0px_var(--color-primary)] transition-all duration-300 border-0">
                <Link to="/ContactsPage">
                  Richiedi una consulenza
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
              
              <Button asChild variant="ghost" size="lg" className="text-foreground hover:text-primary hover:bg-secondary/50 border border-transparent hover:border-border transition-all">
                
              </Button>
            </div>

            <div className="pt-8 grid grid-cols-2 md:grid-cols-3 gap-6 border-t border-border/30 mt-8">
              {[{
              label: "Esperienza",
              value: "10+ Anni"
            }, {
              label: "Focus",
              value: "B2B & Enterprise"
            }, {
              label: "Supporto",
              value: "On-site & Remoto"
            }].map((stat, i) => <div key={i} data-index={i} className="text-center lg:text-left">
                  <div className="text-2xl font-bold text-white">{stat.value}</div>
                  <div className="text-sm text-muted-foreground font-mono mt-1">{stat.label}</div>
                </div>)}
            </div>
          </div>

          {}
          <div ref={containerRef} className="w-full lg:w-2/5 h-[400px] lg:h-[500px] relative flex items-center justify-center">
            <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent z-10 pointer-events-none" />
            <div className="w-full h-full rounded-xl overflow-hidden border border-border/20 bg-secondary/10 backdrop-blur-sm shadow-2xl">
              {parentWidth > 0 && <Sketch setup={setup} draw={draw} windowResized={windowResized} />}
            </div>
            
            {}
            <div className="absolute top-4 left-4 w-2 h-2 bg-primary rounded-full z-20" />
            <div className="absolute top-4 right-4 w-2 h-2 bg-primary/50 rounded-full z-20" />
            <div className="absolute bottom-4 left-4 w-2 h-2 bg-primary/50 rounded-full z-20" />
            <div className="absolute bottom-4 right-4 w-2 h-2 bg-primary rounded-full z-20" />
            
            <div className="absolute top-1/2 left-0 w-full h-[1px] bg-primary/10 z-20 pointer-events-none" />
            <div className="absolute left-1/2 top-0 w-[1px] h-full bg-primary/10 z-20 pointer-events-none" />
          </div>

        </div>
      </div>
    </section>;
}